import axios from 'axios';

// API base URL - uses environment variable in production, localhost in development
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Create axios instance with default configuration
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available (for mobile browsers that block cookies)
api.interceptors.request.use((config) => {
  const authToken = localStorage.getItem('authToken');
  if (authToken) {
    config.headers['Authorization'] = `Token ${authToken}`;
  }
  return config;
});

// Helper to save auth token
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('authToken', token);
  } else {
    localStorage.removeItem('authToken');
  }
};

// Helper to get auth token
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Helper to clear auth token
export const clearAuthToken = () => {
  localStorage.removeItem('authToken');
};

export default api;
